import { Navigate, Outlet } from "react-router-dom";

import { type AvailableRoles, usePermissions } from "@/providers/PermissionsProvider";

type ProtectedRouteProps = {
  requiredRoles: AvailableRoles[];
  redirectTo: string;
  /**
   * Permissões que valem como alternativa entre si: basta o token ter uma delas. Somam-se
   * a `requiredRoles` em vez de substituí-lo — a role continua sendo o corte grosso, e
   * isso aqui é para quando o acesso é liberado permissão a permissão, sem role própria.
   */
  requiredAnyPermissions?: string[];
};

const ProtectedRoute = ({
  requiredRoles,
  redirectTo = "/",
  requiredAnyPermissions,
}: ProtectedRouteProps) => {
  const { userRole, permissions, isLoading } = usePermissions();

  if (isLoading) {
    return null;
  }

  if ((!userRole || !requiredRoles.includes(userRole))) {
    return <Navigate to={redirectTo} />;
  }

  if (requiredAnyPermissions?.length && !requiredAnyPermissions.some((permission) => permissions.includes(permission))) {
    return <Navigate to={redirectTo} />;
  }

  return <Outlet />;
};

export { ProtectedRoute, type ProtectedRouteProps };
